module.exports = __webpack_public_path__ + "static/img/103755.e09a69e9.png";